import React, { useState } from 'react';
import { number, string } from 'prop-types';
import IconAlert from './icons/IconAlert';
import IconClose from './icons/IconClose';
import IconCheck from './icons/IconCheck';

const WarningToast = ({ title, message, type, successCount }) => {
  const [display, setDisplay] = useState('');
  const closeWarning = () => {
    setDisplay('none');
  };
  let successMsg = '';
  if (successCount > 0 && successCount === 1) {
    successMsg = `${successCount} definition was ${message}`;
  } else if (successCount > 1) {
    successMsg = `${successCount} definitions were ${message}`;
  }

  return (
    <div
      className="de--warning--card"
      style={{
        display,
        backgroundColor:
          type === 'success' ? '#4FE352' : 'rgba(247, 222, 6, 0.8)',
      }}
    >
      {type !== 'error' && (
        <button
          className="de--warning--card__close"
          type="button"
          onClick={closeWarning}
        >
          <IconClose size={8} />
        </button>
      )}
      {successCount ? <div className="de--warning--card__icon-success">
        <IconCheck />
      </div> : <div className="de--warning--card__icon">
        <IconAlert />
      </div>}
      <div className="de--warning--card__content">
        <div className="de--warning--card__header">{title}</div>
        <div className="de--warning--card__message">
          {successCount ? successMsg : message}
        </div>
      </div>
    </div>
  );
};

WarningToast.propTypes = {
  title: string,
  message: string,
  type: string,
  successCount: number,
};

export default WarningToast;
